<template>
    <l-layout :layou="['xs12']">
      <v-layout justiyf-center class="pl-3">
        <v-flex xs8>
          <l-plate-picker label="车辆号牌" v-model="plate"></l-plate-picker>
        </v-flex>
        <v-flex xs4 class="pt-2">
          <v-btn flat color="primary" @click="getBillHistory">查询</v-btn>
        </v-flex>
      </v-layout>
      <v-subheader>账单记录</v-subheader>
      <v-card v-for="(b,i) in billList" :key="i" class="pa-3 mt-2">
        <v-layout>
          <v-flex xs10>
            <v-layout column>
              <v-flex xs12>
                <span>创建时间:{{$L.time.stringify(new Date(b.creationTime))}}</span>
              </v-flex>
              <v-flex xs12>
                <span>账单状态:{{BILL_STATUS_TEXT[b.status]}}</span>
              </v-flex>
              <v-flex xs12>
                <span>账单描述:{{b.description}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2>
            <v-layout justify-center>
              <v-btn flat color="primary" @click="goToBillDetails(b)">查看</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </l-layout>
</template>

<script>
import LPlatePicker from '../../components/LPlatePicker'
import LDataCard from '@/components/LDataCard'
export default {
  name: 'billList_wx',
  components: {LPlatePicker, LDataCard},
  data () {
    return {
      plate: '',
      billList: [],
      BILL_STATUS_TEXT:{
        'unsettled': '账单未结算',
        'settled_unpaid': '账单未支付',
        'settled_additional': '账单尚有补交费用未支付',
        'paid': '账单已支付'
      }
    }
  },
  methods: {
    async getBillHistory () {
      let pagination = {pages: 1, rowsPerPage: 100}
      let parkId = (this.$route.query.parkId===undefined)?'':this.$route.query.parkId
      let {items, amount} = await this.$store.dispatch('pay/getBillList', {
        pagination,
        search: {key: 'plate', value: this.plate},
        filter:[{key:'currentParkId',value:parkId}]
      })
      this.billList = items
      return {items, amount}
    },
    goToBillDetails (data) {
      this.$router.push({name: 'billDetailsWx',
        query: {
          billId: data.id
        }})
    },
  }
}
</script>

<style scoped>

</style>
